import { postApi, } from '../components/Utility'
import {
    action,
    makeObservable,
    observable,
} from 'mobx';
import { message } from 'antd';

class DriverExpenseReportStore {
    expenseReport = []
    total = 0
    loading = false
    rootStore
    rec = 0

    constructor(rootStore) {
        makeObservable(this, {
            expenseReport: observable,
            total: observable,
            loading: observable,
            rec: observable,

            loadData: action,
            exportExcel: action,
            exportpdf: action,

        });
        this.rootStore = rootStore;

    }

    async loadData({ offset, limit, companyId, fromDate, toDate, driverId }) {
        this.loading = true
        var postData = { "companyId": companyId, "driverId": driverId, "fromDate": fromDate, "toDate": toDate, "offset": offset, "limit": limit, "page": 1 }

        var response = await postApi.getClient('report').post("/driver_report/expanseReport", postData);

        this.expenseReport = response?.data?.data?.expancelist
        this.total = parseInt(response?.data?.data?.TotalCount);
        this.loading = false;
    }
    

    async exportExcel(getDta) {

        try {
            await postApi.getClient("report").post("/driver_report/expanseReport/download/excel", getDta, {
                responseType: "blob",
            });
            this.pythonReportMessage = true;

        } catch (error) {
            this.pythonReportErrorMessage = true;
            message.error("Failed to download the report. Please try again.");
        }


    }

    async exportpdf(getDta) {
        try {
            await postApi.getClient("report").post("/driver_report/expanseReport/download/pdf", getDta, {
                responseType: "blob",
            });
            this.pythonReportMessage = true;

        } catch (error) {
            this.pythonReportErrorMessage = true;
            message.error("Failed to download the report. Please try again.");
        }
    }



}

export default DriverExpenseReportStore;
